import Footer from '../../components/Commons/Footer';
import NavBar from '../../components/Commons/NavBar';
import MovieCard from '../../components/Movies/MovieCard';
import { ListContents, Grid, TitleList, WithoutContent, CardWrapper } from './style';
import EmptyList from '../../assets/icon-empty.svg';
import { useState } from 'react';
import { useEffect } from 'react';
import GridSkeleton from '../../components/Commons/GridSkeleton';
import { getContentTag, getTrailTag } from '../../services/tags';

const NoContent = () => (
  <WithoutContent>
    <div>
      <img src={EmptyList} alt="" />
    </div>
    <p>Nenhum conteúdo a esta categoria no momento. Navegue pelo catálogo para encontrar mais conteúdos.</p>
  </WithoutContent>
);

export default function Courses() {
  const [courses, setCourses] = useState<any>();

  const getData = async () => {
    const content = await getContentTag('cursos');
    const trail = await getTrailTag('cursos');
    setCourses(content.concat(trail));
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <NavBar />
      <ListContents>
        <TitleList>Cursos</TitleList>
        {!courses && <GridSkeleton />}
        {courses?.length <= 0 && <NoContent />}
        <Grid>
          {courses &&
            courses.map((course: any, key: any) => {
              if (course?.is_library) {
                return (
                  <CardWrapper>
                    <MovieCard to={`/movie/${course.content_id}`} data={course} key={`course-${key}`} />
                  </CardWrapper>
                );
              } else {
                return (
                  <CardWrapper>
                    <MovieCard to={`/trail/${course.trail_id}`} data={course} key={`course-${key}`} />
                  </CardWrapper>
                );
              }
            })}
        </Grid>
      </ListContents>
      <Footer />
    </div>
  );
}
